import "./ProfesionalCardItem.css"
import ExperienceFlow from "../../containers/ExperienceFlow/ExperienceFlow"

// Helper function to calculate duration automatically
function calculateDuration(startDate, endDate) {
	const start = new Date(startDate + " 1") // add day so JS can parse it
	const end = endDate.toLowerCase() === "current" ? new Date() : new Date(endDate + " 1")

	let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth())

	const years = Math.floor(months / 12)
	months = months % 12

	let result = []
	if (years > 0) result.push(`${years} year${years > 1 ? "s" : ""}`)
	if (months > 0) result.push(`${months} month${months > 1 ? "s" : ""}`)

	return result.length > 0 ? result.join(" ") : "Less than a month"
}

const workExperience = [
	{
		id: 1,
		position: "Support Member",
		company: "Softtek",
		startDate: "November 2023",
		endDate: "Current",
		description: `- Provided application management and production support for enterprise systems, ensuring availability and adherence to SLAs.
					  - Resolved incidents and service requests, collaborating with business and technical teams to minimize downtime.
					  - Documented procedures and created knowledge base articles to improve incident resolution efficiency.
					  - Developed SQL queries and performed basic data fixes to support business operations.
					  - Assigned incoming tickets to the appropriate team members or resolved them directly when within my scope.`,
		certify: "https://www.linkedin.com/in/belsanto/details/experience/",
		skills: ["SQL Server", "Incident Management", "Technical Support", "AMS", "Troubleshooting"],
	},
	{
		id: 2,
		position: "Software Developer",
		company: "Technologies of Colombia",
		startDate: "January 2023",
		endDate: "July 2023",
		description: `- Collaborated on a JAVA project involving the creation of SOAP services.
					  - Developed, integrated, optimized, and conducted thorough manual testing of different modules of clinical software using APEX, contributing to the creation of PL/SQL functions/procedures and employing advanced querying techniques.
					  - Provided support and guidance for users regarding code-related errors and software usage.
					  - Successfully collaborated with oncological companies in the country for software implementation changes and bug fixes.`,
		certify: "https://www.linkedin.com/in/belsanto/details/experience/",
		skills: ["JavaScript", "CSS", "Oracle SQL", "APEX", "PL/SQL", "Java", "SOAP"],
	},
	{
		id: 3,
		position: "Software Programming Technician",
		company: "Multipurpose Company of Calarcá",
		startDate: "September 2018",
		endDate: "March 2019",
		description: `- Designed and fully developed a functional software solution using HTML, JAVA, and MySQL for the customer service department, enhancing efficiency and enabling faster, more accurate customer service.
					  - Designed and implemented an internal corporate website with WordPress that improved the productivity of 70% of the company's work teams, reducing time spent searching for information.
					  - Identified and corrected 10 code defects in PHP-based applications, leading to notable improvements in work efficiency for approximately 80% of the staff.`,
		certify: "https://www.linkedin.com/in/belsanto/details/experience/",
		skills: ["Java SE", "MySQL", "PHP", "CSS", "HTML", "WordPress"],
	},
]

function ProfesionalCardItem() {
	return (
		<div className="card card-section">
			<section className="card-title">
				<h1 className="big-tittle">Professional Work Experience</h1>
			</section>
			<ExperienceFlow
				experiences={workExperience.map((exp) => ({
					...exp,
					time: calculateDuration(exp.startDate, exp.endDate), // inject duration here
				}))}
			/>
		</div>
	)
}

export { ProfesionalCardItem }
